export default "__VITE_ASSET__CoarO8QW__"